export default[
    {
        path: '/decimo/lista',
        name: 'lista do decimo', 
        component: () => import(/* webpackChunkName: "Login" */ './page/lista.vue')
    },
    {
        path: '/decimo/cadastro',
        name: 'cadastro do decimo', 
        component: () => import(/* webpackChunkName: "Login" */ './page/cadastro.vue')
    },
    {
        path: '/decimo/editar/:id',
        name: 'editar decimo', 
        component: () => import(/* webpackChunkName: "Login" */ './page/editar.vue')
    },
]